// Academy contact details — fill these in when the owner shares them.
// While a field is empty, the site shows a clearly-marked placeholder
// instead of the live button, address or map. Nothing here is invented.
export const ACADEMY = {
  name: "Gautam Chess Classes",
  phoneDisplay: "+91 63017 41808",
  phone: "+916301741808", // tel: link value
  whatsapp: "916301741808", // wa.me digits only
  address: "Chaya Pre School, PJR Colony, Kondapur, Hyderabad", // drives the Google Maps embed
  whatsappMessage: "Hi Gautam Chess Classes! I'd like to book a free trial class.",
};

export const hasPhone = Boolean(ACADEMY.phone);
export const hasWhatsapp = Boolean(ACADEMY.whatsapp);
export const hasAddress = Boolean(ACADEMY.address);

export const whatsappLink = hasWhatsapp
  ? `https://wa.me/${ACADEMY.whatsapp}?text=${encodeURIComponent(ACADEMY.whatsappMessage)}`
  : "";

export const mapsEmbedUrl = hasAddress
  ? `https://www.google.com/maps?q=${encodeURIComponent(ACADEMY.address)}&output=embed`
  : "";
